var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inputClass"},[_c('TextInput',{attrs:{"name":_vm.name,"id":_vm.id,"value":_vm.value,"placeholder":_vm.placeholder}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }